
import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen py-20 px-6 bg-gray-50 dark:bg-gray-800">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-gray-900 dark:text-white">
            Terms of Service
          </h1>
          
          <div className="bg-white dark:bg-gray-900 rounded-lg shadow-lg p-8">
            <div className="prose prose-lg max-w-none dark:prose-invert">
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Last updated: January 1, 2024
              </p>
              
              <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Acceptance of Terms</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                By accessing and using Rust-Squad.com services, you accept and agree to be bound by the terms and provision of this agreement.
              </p>
              
              <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Service Description</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Rust-Squad.com provides professional rust removal, prevention, and protection services for automotive, marine, and industrial equipment.
              </p>
              
              <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Limitations of Liability</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Rust-Squad.com shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services.
              </p>
              
              <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Contact Information</h2>
              <p className="text-gray-600 dark:text-gray-300">
                For questions about these Terms of Service, please contact us at contact@rust-squad.com.
              </p>
            </div>
          </div>
        </div>
      </div>
  );
};

export default TermsOfService;
